import { LargeListSkeleton } from '@Components/General/Skeletons';
import { createFileRoute } from '@tanstack/react-router';
import { emailTemplatesQueryOptions } from '@utils/queryOptions';
import EmailTemplates from '@Views/Emails/templates';

export const Route = createFileRoute('/emails/templates/')({
    component: EmailTemplates,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailTemplatesQueryOptions(opts.deps),
        ),
    loaderDeps: ({ search }) => search,
    pendingComponent: LargeListSkeleton,
});
